/**
 * @link https://mui.com/material-ui/react-avatar/
 */

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { deepPurple } from '@mui/material/colors';
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeAvatar() {
  return (
    <>
      <Stack direction="row" spacing={2} sx={{mb: 5}}>
        <Avatar>LS</Avatar>
        <Avatar variant="sales">CW</Avatar>
        <Avatar variant="purchase">MK</Avatar>
        <Avatar variant="qm">BS</Avatar>
        <Avatar sx={{ bgcolor: deepPurple[500] }}>FW</Avatar>
      </Stack>
      
      <ShowCode 
        codeString={`<>
  <Stack direction="row" spacing={2}>
    {/* Default Avatar with initials */}
    <Avatar>LS</Avatar>
    
    {/* Custom variant Avatars */}
    <Avatar variant="sales">CW</Avatar>
    <Avatar variant="purchase">MK</Avatar>
    <Avatar variant="qm">BS</Avatar>
    
    {/* Avatar with custom background color */}
    <Avatar sx={{ bgcolor: deepPurple[500] }}>FW</Avatar>
  </Stack>
</>`} 
        scope={{ React, Avatar, Stack, deepPurple }} 
      />
    </>
  );
}